import PropTypes from 'prop-types';

import { Container } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { breakpoints } from 'styles/theme.variables';

import { Dock } from 'primitives/Dock/Dock';

export default function DockedDrawerFormContent({
  children,
  dockBottomPadding,
  dockButtons,
  minHeight: minHeightOverride,
  size,
  stacked,
}) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);
  const drawerSize = size || (isMobile ? 'sm' : 'lg');
  // View height - height of dock + height of title
  const defaultMinHeight = drawerSize === 'lg' ? 'calc(100vh - 172px)' : 'calc(100vh - 148px)';
  const minHeight = minHeightOverride ?? defaultMinHeight;

  return (
    <>
      <Container
        data-testid="docked-drawer-content"
        px={drawerSize === 'lg' ? 'xl' : 'sm'}
        mih={minHeight}
      >
        {children}
      </Container>
      <Dock pb={dockBottomPadding} stacked={stacked} size={drawerSize}>
        {dockButtons}
      </Dock>
    </>
  );
}

DockedDrawerFormContent.propTypes = {
  children: PropTypes.node,
  dockBottomPadding: PropTypes.string,
  dockButtons: PropTypes.node,
  /** Replaces the default, for a drawer whose title row is not the default height. */
  minHeight: PropTypes.string,
  size: PropTypes.string,
  stacked: PropTypes.bool,
};
